/* ============================================================
   Notre Chanson — composer.js
   Drives the 6-step song-brief quiz: navigation, validation,
   dynamic (name/gender-aware) copy, per-relation quality chips,
   adaptive memory prompts, and full persistence via NM (store.js).
   On finalize → recap.html.
   ============================================================ */
(function () {
  'use strict';

  var A = NM.answers;                 // live answers object (stable ref)

  /* ---- Step model ---- */
  var ORDER  = ['1a', '1b', '2', '3', '4', '5'];
  var CONFIG = {
    '1a': { num: 1, pct: 17 }, '1b': { num: 2, pct: 33 }, '2': { num: 3, pct: 50 },
    '3':  { num: 4, pct: 67 }, '4':  { num: 5, pct: 83 }, '5': { num: 6, pct: 100 }
  };

  /* ---- Per-relation step-1b copy ---- */
  var STEP1 = {
    femme:{h1:'votre femme'}, mari:{h1:'votre mari'}, copine:{h1:'votre copine'}, copain:{h1:'votre copain'},
    mere:{h1:'votre mère'}, pere:{h1:'votre père'},
    enfants:{h1:'votre enfant', sub:'Pour plusieurs enfants, séparez les prénoms par une virgule.', ph:'Marie, Lucas…'},
    fratrie:{h1:'votre frère ou votre sœur'}, ami:{h1:'votre ami(e)'},
    moi:{h1:'vous', self:true}, autre:{h1:'cette personne'}
  };

  /* ---- Quality pools per relation (gender-agreed adjectives) ---- */
  var QUALS = {
    femme:['Attentionnée','Forte','Généreuse','Douce','Patiente','Courageuse','Protectrice','Romantique','Fiable','Spontanée','Drôle','Énergique','Sage','Aventurière','Empathique'],
    mari:['Attentionné','Fort','Généreux','Doux','Patient','Courageux','Protecteur','Romantique','Fiable','Spontané','Drôle','Énergique','Sage','Aventurier','Empathique'],
    copine:['Drôle','Généreuse','Douce','Courageuse','Attentionnée','Protectrice','Patiente','Forte','Spontanée','Fiable','Romantique','Empathique','Énergique','Sage','Aventurière'],
    copain:['Drôle','Généreux','Doux','Courageux','Attentionné','Protecteur','Patient','Fort','Spontané','Fiable','Romantique','Empathique','Énergique','Sage','Aventurier'],
    mere:['Généreuse','Forte','Courageuse','Protectrice','Attentionnée','Douce','Patiente','Drôle','Sage','Fiable','Empathique','Spontanée','Énergique','Aventurière','Romantique'],
    pere:['Généreux','Fort','Courageux','Protecteur','Attentionné','Doux','Patient','Drôle','Sage','Fiable','Empathique','Spontané','Énergique','Aventurier','Romantique'],
    enfants:['Fort','Courageux','Empathique','Protecteur','Aventurier','Généreux','Doux','Patient','Drôle','Spontané','Créatif','Énergique','Sage','Fiable','Attentionné'],
    fratrie:['Drôle','Généreux','Fiable','Empathique','Spontané','Patient','Courageux','Attentionné','Doux','Sage','Fort','Aventurier','Énergique','Romantique','Créatif'],
    ami:['Drôle','Généreux','Fiable','Empathique','Spontané','Sage','Patient','Attentionné','Doux','Aventurier','Courageux','Énergique','Fort','Créatif','Romantique'],
    moi:['Drôle','Généreux','Patient','Doux','Fort','Courageux','Attentionné','Spontané','Sage','Créatif','Aventurier','Empathique','Fiable','Romantique','Énergique'],
    autre:['Drôle','Généreux','Patient','Doux','Fort','Courageux','Attentionné','Spontané','Sage','Créatif','Aventurier','Empathique','Fiable','Romantique','Énergique']
  };
  var PARTNER = { femme:1, mari:1, copine:1, copain:1 };

  /* ---- DOM refs ---- */
  var $ = function (id) { return document.getElementById(id); };
  var views = document.querySelectorAll('[data-step]');
  var counter = $('quiz-counter'), pct = $('quiz-pct'), fill = $('quiz-fill');
  var cta = $('quiz-cta'), btnBack = $('btn-back'), btnNext = $('btn-next'), btnNextLabel = $('btn-next-label');
  var prenom = $('prenom'), pronToggle = $('pron-toggle'), pronWrap = $('pron-wrap'), pron = $('pronunciation');
  var souvenirs = $('souvenirs'), message = $('message');

  var current = '1a';

  /* ---- Helpers ---- */
  function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  function nameSpan() { return '<span class="accent">' + esc(NM.displayName()) + '</span>'; }
  function autoGrow(el) { el.style.height = 'auto'; el.style.height = el.scrollHeight + 'px'; }

  /* ---- Navigation ---- */
  function setProgress(p) { fill.style.width = p + '%'; }

  function showStep(step, isReturn) {
    if (step !== '1a' && !A.relation) step = '1a';
    current = step;
    NM.setStep(step);
    views.forEach(function (v) { v.hidden = (v.dataset.step !== step); });

    var cfg = CONFIG[step];
    counter.textContent = 'Étape ' + cfg.num + ' sur 6';
    pct.textContent = cfg.pct + ' % complété';
    setProgress(cfg.pct);

    refreshCopy(step);
    configureCTA(step);

    cta.classList.toggle('nm-quiz-cta--start', step === '1a');
    window.scrollTo({ top: 0, behavior: isReturn ? 'auto' : 'smooth' });
  }

  function configureCTA(step) {
    if (step === '1a') {
      btnBack.hidden = true;
      btnNext.hidden = !A.relation;
      btnNext.classList.toggle('is-ready', !!A.relation);
      btnNextLabel.textContent = 'Suivant →';
      btnNext.classList.remove('is-final');
      return;
    }
    btnBack.hidden = false;
    btnNext.hidden = false;
    if (step === '5') {
      btnNextLabel.textContent = 'Finaliser →';
      btnNext.classList.add('is-final');
      btnNext.classList.remove('is-ready');
    } else {
      btnNextLabel.textContent = 'Suivant →';
      btnNext.classList.remove('is-final');
      syncReady(step);
    }
  }

  function syncReady(step) {
    var ready = false;
    if (step === '1b') ready = A.prenom.trim().length > 0;
    else if (step === '2') ready = !!A.genre;
    else if (step === '3') ready = A.qualities.trim().length > 0;
    else if (step === '4') ready = true;   // souvenirs optional
    btnNext.classList.toggle('is-ready', ready);
  }

  function refreshCopy(step) {
    if (step === '1b') refresh1b();
    else if (step === '2') $('title-2').innerHTML = 'Quel genre pour ' + nameSpan() + '&nbsp;?';
    else if (step === '3') { $('title-3').innerHTML = 'Qu\'est-ce qui rend ' + nameSpan() + ' unique&nbsp;?'; renderQuals(); }
    else if (step === '4') { $('title-4').innerHTML = 'Partagez vos souvenirs avec ' + nameSpan(); renderSouvStarters(); }
  }

  function refresh1b() {
    var c = STEP1[A.relation] || STEP1.autre;
    if (c.self) $('title-1b').innerHTML = 'Comment <span class="accent">vous</span> appelez-vous&nbsp;?';
    else $('title-1b').innerHTML = 'Comment s\'appelle <span class="accent">' + esc(c.h1) + '</span>&nbsp;?';
    $('sub-1b').textContent = c.sub || (c.self ? 'Pour personnaliser votre chanson.' : 'Pour personnaliser la chanson.');
    prenom.placeholder = c.ph || (c.self ? 'Entrez votre prénom' : 'Entrez son prénom');
  }

  /* ---- Step 1a: relation (auto-advance) ---- */
  document.getElementById('relation-grid').addEventListener('click', function (e) {
    var btn = e.target.closest('.nm-relation');
    if (!btn) return;
    this.querySelectorAll('.nm-relation').forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false'); });
    btn.classList.add('is-selected'); btn.setAttribute('aria-checked', 'true');
    NM.setAnswer('relation', btn.dataset.relation);
    try { if (navigator.vibrate) navigator.vibrate(15); } catch (e2) {}
    btn.blur();
    setTimeout(function () { showStep('1b'); }, 300);
  });

  /* ---- Step 1b: prénom ---- */
  prenom.addEventListener('input', function () {
    NM.setAnswer('prenom', prenom.value);
    prenom.classList.toggle('is-valid', prenom.value.trim().length > 0);
    $('error-1b').hidden = true;
    syncReady('1b');
  });
  pronToggle.addEventListener('click', function () {
    var open = pronWrap.hidden;
    pronWrap.hidden = !open;
    pronToggle.setAttribute('aria-expanded', String(open));
    if (open) pron.focus();
  });
  pron.addEventListener('input', function () { NM.setAnswer('pronunciation', pron.value); });

  /* ---- Step 2: genre + voice ---- */
  document.getElementById('genre-grid').addEventListener('click', function (e) {
    var chip = e.target.closest('.nm-chip'); if (!chip) return;
    this.querySelectorAll('.nm-chip').forEach(function (c) { c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false'); });
    chip.classList.add('is-selected'); chip.setAttribute('aria-checked', 'true');
    NM.setAnswer('genre', chip.dataset.genre);
    $('error-2').hidden = true;
    syncReady('2');
  });
  document.getElementById('voice-grid').addEventListener('click', function (e) {
    var chip = e.target.closest('.nm-chip'); if (!chip) return;
    var was = chip.classList.contains('is-selected');
    this.querySelectorAll('.nm-chip').forEach(function (c) { c.classList.remove('is-selected'); c.setAttribute('aria-checked', 'false'); });
    if (!was) { chip.classList.add('is-selected'); chip.setAttribute('aria-checked', 'true'); NM.setAnswer('voice', chip.dataset.voice); }
    else NM.setAnswer('voice', null);
  });

  /* ---- Step 3: qualities ---- */
  function renderQuals() {
    var list = $('qual-chips');
    if (list.dataset.rel === A.relation) return;   // already built for this relation
    list.dataset.rel = A.relation;
    var pool = QUALS[A.relation] || QUALS.autre;
    var picked = (A.qualities || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    list.innerHTML = '';
    pool.forEach(function (q) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'nm-qual'; b.textContent = q;
      if (picked.indexOf(q) !== -1) b.classList.add('is-selected');
      li.appendChild(b); list.appendChild(li);
    });
  }
  $('qual-chips').addEventListener('click', function (e) {
    var b = e.target.closest('.nm-qual'); if (!b) return;
    b.classList.toggle('is-selected');
    var picked = Array.prototype.map.call(this.querySelectorAll('.nm-qual.is-selected'), function (x) { return x.textContent; });
    NM.setAnswer('qualities', picked.join(', '));
    $('error-3').hidden = true;
    syncReady('3');
  });
  var qualToggle = $('qual-toggle'), qualExtra = $('qual-extra'), qualExtraInput = $('qual-extra-input');
  qualToggle.addEventListener('click', function () {
    var open = qualExtra.hidden; qualExtra.hidden = !open;
    qualToggle.setAttribute('aria-expanded', String(open));
    if (open) qualExtraInput.focus();
  });

  /* ---- Step 4: souvenirs + adaptive prompts ---- */
  function souvPrompts() {
    var rel = A.relation || 'autre';
    var g = NM.gender();
    var isPartner = !!PARTNER[rel];
    var slot1 = isPartner ? 'Notre première rencontre' : 'Un moment que je n\'oublierai jamais';
    var QUAL = {
      drole:'Un fou rire inoubliable', romantique:'Notre premier baiser', aventur:'Un voyage à deux',
      doux:'Un moment de tendresse', patient:'Une étape traversée ensemble', empath:'Un moment de complicité',
      genereu:'Un geste qui m\'a touché(e)', fort:'Une force qui m\'a portée', fiable:'Une promesse tenue',
      courageu:'Un acte de courage', attentionn:'Une attention qui m\'a touché(e)', energ:'Sa joie de vivre',
      creat:'Un moment unique créé', sage:'Un conseil que je garde', protect:'Un moment de soutien', spontan:'Sa plus belle surprise'
    };
    var REL = {
      femme:'Un voyage à deux', mari:'Un voyage à deux', copine:'Un voyage à deux', copain:'Un voyage à deux',
      mere:'Une leçon qu\'elle m\'a apprise', pere:'Une leçon qu\'il m\'a apprise',
      enfants: A.prenom.indexOf(',') !== -1 ? 'Leurs premiers pas' : 'Sa naissance',
      fratrie:'Notre enfance partagée', ami:'Un fou rire inoubliable', moi:'Un moment qui m\'a transformé(e)', autre:'Un moment précieux'
    };
    var picked = (A.qualities || '').toLowerCase();
    var slot2 = null;
    Object.keys(QUAL).some(function (k) { if (picked.indexOf(k) !== -1) { slot2 = QUAL[k]; return true; } return false; });
    if (!slot2) slot2 = 'Un fou rire inoubliable';
    var slot3 = REL[rel] || 'Un moment précieux';
    var out = [slot1];
    if (out.indexOf(slot2) === -1) out.push(slot2);
    if (out.indexOf(slot3) === -1) out.push(slot3);
    ['Un voyage à deux', 'Un moment de complicité', 'Une phrase qu\'on se répète souvent'].forEach(function (f) {
      if (out.length < 3 && out.indexOf(f) === -1) out.push(f);
    });
    return out.slice(0, 3);
  }
  function renderSouvStarters() {
    var list = $('souv-starters');
    list.innerHTML = '';
    souvPrompts().forEach(function (label) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'nm-starter'; b.dataset.starter = label + ' — ';
      b.innerHTML = '<span class="nm-starter__ic" aria-hidden="true">+</span>' + esc(label) + '…';
      li.appendChild(b); list.appendChild(li);
    });
  }
  souvenirs.addEventListener('input', function () { NM.setAnswer('souvenirs', souvenirs.value); $('error-4').hidden = true; autoGrow(souvenirs); });
  $('souv-starters').addEventListener('click', function (e) { insertStarter(e, souvenirs, 'souvenirs'); });

  /* ---- Step 5: message ---- */
  message.addEventListener('input', function () { NM.setAnswer('message', message.value); autoGrow(message); });
  document.getElementById('msg-starters').addEventListener('click', function (e) { insertStarter(e, message, 'message'); });

  function insertStarter(e, field, key) {
    var b = e.target.closest('.nm-starter'); if (!b) return;
    var text = b.dataset.starter;
    var cur = field.value.trim();
    field.value = cur ? cur + '\n' + text : text;
    NM.setAnswer(key, field.value);
    field.focus();
    field.setSelectionRange(field.value.length, field.value.length);
    autoGrow(field);
    if (key === 'souvenirs') { $('error-4').hidden = true; }
  }

  /* ---- Validation + advance ---- */
  function validate(step) {
    if (step === '1b') {
      if (A.prenom.trim().length === 0) { $('error-1b').hidden = false; prenom.focus(); return false; }
    } else if (step === '2') {
      if (!A.genre) { $('error-2').hidden = false; return false; }
    } else if (step === '3') {
      if (A.qualities.trim().length === 0) {
        // allow "own words" alone to satisfy the step
        if (qualExtraInput.value.trim().length === 0) { $('error-3').hidden = false; return false; }
      }
    }
    return true;
  }

  btnNext.addEventListener('click', function () {
    if (!validate(current)) return;
    // Merge "own words" into qualities on leaving step 3
    if (current === '3' && qualExtraInput.value.trim()) {
      var extra = qualExtraInput.value.trim();
      var base = A.qualities.trim();
      NM.setAnswer('qualities', base ? base + ', ' + extra : extra);
    }
    var idx = ORDER.indexOf(current);
    if (idx < ORDER.length - 1) { showStep(ORDER[idx + 1]); }
    else { finalize(); }
  });

  btnBack.addEventListener('click', function () {
    var idx = ORDER.indexOf(current);
    if (idx > 0) showStep(ORDER[idx - 1], true);
  });

  function finalize() {
    NM.setAnswer('message', message.value);
    NM.setStep('done');
    window.location.href = NM.route('recap');
  }

  /* ---- Restore prior answers into the DOM ---- */
  function restore() {
    if (A.relation) {
      var rb = document.querySelector('.nm-relation[data-relation="' + A.relation + '"]');
      if (rb) { rb.classList.add('is-selected'); rb.setAttribute('aria-checked', 'true'); }
    }
    if (A.prenom) { prenom.value = A.prenom; prenom.classList.add('is-valid'); }
    if (A.pronunciation) { pron.value = A.pronunciation; pronWrap.hidden = false; pronToggle.setAttribute('aria-expanded', 'true'); }
    if (A.genre) { var gb = document.querySelector('.nm-chip[data-genre="' + A.genre + '"]'); if (gb) { gb.classList.add('is-selected'); gb.setAttribute('aria-checked', 'true'); } }
    if (A.voice) { var vb = document.querySelector('.nm-chip[data-voice="' + A.voice + '"]'); if (vb) { vb.classList.add('is-selected'); vb.setAttribute('aria-checked', 'true'); } }
    if (A.souvenirs) { souvenirs.value = A.souvenirs; }
    if (A.message) { message.value = A.message; }
  }

  /* ---- Boot ---- */
  restore();
  // Resume where the user left off (unless they finished; then restart the brief).
  var start = NM.state.currentStep;
  if (!start || start === 'done' || ORDER.indexOf(start) === -1) start = '1a';
  showStep(start, true);
})();
